import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { TopbarStateService } from './services/topbar-state.service';

@Injectable({
  providedIn: 'root'
})
export class OffGameGuard implements CanActivate {
  constructor(private topbarState: TopbarStateService) {

  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    this.topbarState.state = false;
    return true;
  }

}
